"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { DomId } from "@/vendors/GoogleTag/config/ad-slots.config";
type AdSlot = {
  readonly domId: DomId;
  readonly onBeforeShow?: (isEmpty: boolean) => void;
};
export function useAdSlot(t0) {
  const $ = _c(6);
  const {
    domId,
    onBeforeShow
  } = t0;
  const [isAdEmpty, setIsAdEmpty] = useState(true);
  let t1;
  if ($[0] !== domId || $[1] !== onBeforeShow) {
    t1 = () => {
      window.googletag = window.googletag || {
        cmd: []
      };
      const {
        googletag
      } = window;
      const slotRenderEndedHandler = function slotRenderEndedHandler(t2) {
        const {
          isEmpty,
          slot
        } = t2;
        const currentSlotId = slot.getSlotElementId();
        if (currentSlotId !== domId) {
          return;
        }
        setIsAdEmpty(isEmpty);
        onBeforeShow?.(isEmpty);
      };
      googletag.cmd.push(() => {
        googletag.pubads().addEventListener("slotRenderEnded", slotRenderEndedHandler);
      });
      return function cleanUp() {
        googletag.cmd.push(() => {
          googletag.pubads().removeEventListener("slotRenderEnded", slotRenderEndedHandler);
        });
      };
    };
    $[0] = domId;
    $[1] = onBeforeShow;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== isAdEmpty) {
    t3 = {
      isAdEmpty
    };
    $[4] = isAdEmpty;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}